import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Speakers = () => {
  return (
    <React.Fragment>
      <SEO title="Speakers | DMBD 2023" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Plenary Speakers &amp; Invited Speakers
        "
        content="For Participants"
        contentTwo="Plenary Speakers &amp; Invited Speakers
        "
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          {/* <h4>To be released.</h4> */}
          {/* <span>&nbsp;</span> */}
          {/* <p align="justify">
            <h4>Title: Learning uncertainty in image understanding</h4>
            <br />
            <h5>Abstract:</h5>
            There are many questions to answer in image interpretation and understanding. Uncertainty in image analysis needs strong and powerful modelling tools to describe the objects in the images. Artificial intelligence (AI) plays a very important role in the design of a robust tool for image representation. Using some examples from his own work on uncertainty analysis, Prof. Zhou will explore how AI can stimulate new concepts or development of dealing with complicated problems and lead us to novel adventures through these applications.             <br></br>
            <br />
            <h5>Speaker: </h5>
            <p text-align="center">
              <img src="images/avatar/Zhou.png" alt="Zhou" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. Huiyu Zhou</div>
                School of Computing and Mathematical Sciences, University of Leicester, UK.
              </strong>
            </p>
            <br />
            <h5>Biography:</h5>
            Dr. Huiyu Zhou received a Bachelor of Engineering degree in Radio Technology from Huazhong University of Science and Technology of China,
            and a Master of Science degree in Biomedical Engineering from University of Dundee of United Kingdom, respectively.
            He was awarded a Doctor of Philosophy degree in Computer Vision from Heriot-Watt University, Edinburgh, United Kingdom.
            Dr. Zhou currently is a full Professor at School of Computing and Mathematical Sciences, University of Leicester, United Kingdom.
            He has published over 450 peer-reviewed papers in the field. He was the recipient of &quot;CVIU 2012 Most Cited Paper Award&quot;,
            &quot;MIUA 2020 Best Paper Award&quot;, &quot;ICPRAM 2016 Best Paper Award&quot; and was nominated for &quot;ICPRAM 2017 Best Student Paper Award&quot;
            and &quot;MBEC 2006 Nightingale Prize&quot;. His research work has been or is being supported by UK EPSRC, ESRC, AHRC, MRC, EU, Royal Society,
            Leverhulme Trust, Invest NI, Puffin Trust, Alzheimer’s Research UK, Invest NI and industry.
            <br />
            Homepage: https://le.ac.uk/people/huiyu-zhou
          </p> */}
          {/* <hr />
          <span>&nbsp;</span>
          <p align="justify">
            <h4>Title: Big Data for Healthcare</h4>
            <br />
            <h5>Abstract:</h5>
            Big Data has had a great impact on the healthcare field and will continue to transform health
            systems radically. Every healthcare professional should arm themselves with the knowledge
            to face these changes. Given advice and warnings from some of the top minds like Elon Mush
            and the late Steven Hawkings, it seems inevitable that AI is going into a fast-pace development
            in the next few years and likely to impact every aspect of our lives very soon. This talk will
            describe some of the most important big data applications in healthcare, namely, quality and
            patient safety, early detection of diseases and individualized prevention. We will also discuss
            how Big Data will go hand-in-hand in the future of health care for all the stakeholders, in terms
            of high-performance healthcare and precision medicine.
            On average, a patient generates 80 megabytes of imaging each year. For a healthcare
            organization, this trove of data from patients has an obvious clinical, financial, and operational
            value. However, the value of big data in health care is only realized when this raw information
            is converted into knowledge that changes the practice. The next generation of healthcare
            delivery requires a team effort from data science, delivery science, and implementation science
            to ensure that the right patient receives the right care from the right provider at the right time
            and the right place. In this talk, It will discuss opportunities and challenges faced when
            bringing big data for healthcare illustrated through some of our ongoing efforts.
            <br />
            <h5>Speaker: </h5>
            <p text-align="center">
              <img src="images/avatar/Waqas.png" alt="Waqas" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. Waqas Haider Khan Bangyal</div>
                Kohsar University Murree, Punjab, Pakistan.
              </strong>
            </p>
            <br />
            <h5>Biography:</h5>
            Dr. Waqas Haider Khan Bangyal received his Ph.D. in Computer Science. Dr. Bangyal is
            currently an Associate Professor/Chairperson Department of Computer Science, Kohsar
            University, Murree, Punjab, Pakistan. Dr. Bangyal has over 80 publications, including book
            chapters, journal and conference papers. His publications have been published in the top venue,
            such as IEEE, Elsevier, and Springer. Dr. Bangyal is a Senior Member of IEEE SMC and an
            active Member of ACM and vice president of the INNS Pakistan Chapter. Dr. Bangyal has 20+
            years of global experience in Computer Science, Computer Vision, Artificial Intelligence, IoT,
            Big Data, and block chain. He has also been a facilitator, mentor, and coach for various
            programs. His area of expertise is technology and innovation and he offers advice on how to
            promote and convert ideas into successful products/ solutions as well as build strategies with
            a focus on personal and career development. Dr. Bangyal is serving as an editorial board
            member for various journals including Elsevier, IEEE , Wiley, IEEE Access, IEEE IoT and
            Springer Journals. He has served as the TPC co-chair, publicity co-chair, organization chair,
            and TPC member for many international conferences. He has been a reviewer for prestigious
            journals of Elsevier, Springer, and Wiley publications, and evolved in holding a number of
            events as a member of the executive or technical committee. His research interests include
            Optimization, Machine Learning & Meta-heuristics, Image Processing, and Pattern
            Recognition. He is a member of ACM and IEEE.
            <br />
          </p> */}
          {/* <hr />
          <span>&nbsp;</span> */}

          <p align="justify">
            <h4>Topic: Data Mining for Network Science Analysis</h4>
            <br />
            <h5>Abstract:</h5>
            Data mining techniques have many applications in the field of network science，deep analysis of key technologies in the field of network science, especially in the research work of social networks and complex networks. The main research hotspots in network science are elaborated from micro, meso and macro perspectives; for example, information dissemination, key node identification, community detection, link prediction, recommendation system, rumor detection, sentiment analysis, user privacy protection, etc. At the same time, I will also briefly introduce the main basis and method of analyzing network science. In this keynote topic, we will also discuss the main research directions of network science in the future and the key scientific problems to be solved.
            <br />
            <h5>Speaker: </h5>
            <p text-align="center">
              <img src="images/avatar/xiaoyangliu.png" alt="liuxiaoyang" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Pro. Dr. Xiaoyang Liu</div>
                Chongqing University of Technology, Chongqing, China.
              </strong>
            </p>
            <br />
            <h5>Biography:</h5>
            Pro.Dr. Xiaoyang Liu is a full professor of Computer Science at the Chongqing University of Technology. He has won the second prize of the National Teaching Achievement Award. He is a high-level innovative talent of Elite Plan of Banan District. He received Ph.D. degree in communication and information systems from Northwestern Polytechnical University. He has completed his first Post-doctoral fellow in Chongqing University, China. Then he completed his second Post-doctoral fellow in department of electrical of computer engineering, The University of Alabama, USA. He is a Distinguished Member of CCF, and a member of IEEE and ACM. His main research interests are in the areas of social network, information diffusion, complex network, data mining, computer application. He is a reviewer of IEEE/ACM Transactions on Networking, IEEE Transactions on Cybernetics, Computer Networks and other authoritative journals. He has presided research on more than 50 national and provincial projects such as the National Natural Science Foundation, the National Social Science Foundation, Science and Technology projects of the National Bureau of Statistics and the Ministry of Education. In IEEE Transactions on Network Science and Engineering, IEEE Transactions on Computational Social Systems, Nonlinear Dynamics, Applied Intelligence and other important journals and conferences at home and abroad more than 100 academic papers (SCI included); more than 40 national invention patents have been authorized. He has published 4 academic monographs.
            Homepage: https://nsdm.cqut.edu.cn
            <br />
          </p>
          <hr></hr>
          <p align="justify">
            <h4>Topic: Granular-ball Computing: an Efficient, Robust, and Interpretable Artificial Intelligence Theory and Technology</h4>
            <br />
            <h5>Abstract:</h5>
            Based on the theory of multi-granularity cognitive computing, granular-ball computing method is proposed. This theory employs granular-balls of different granularities to cover data samples, and simulates the ”global-first” cognitive mechanism of the human brain based on a coarse-to-fine generation approach. It can adaptively and efficiently achieve multi-granularity representation of data, forming an efficient, robust, and interpretable multi-granularity computing pattern. This report introduces the relevant research findings and latest developments in the theory of multi-granularity granular-ball computing, including: granular-ball classifiers and granular-ball fuzzy sets that realize efficient and robust classification and fuzzy computation methods for non-point inputs; granular-ball clustering that enhances the efficiency and robustness of existing major clustering methods; granular-ball rough sets that unify classical and neighborhood rough set models, establishing conceptual knowledge representation, implementing neighborhood rough set upper and lower approximation equivalence class knowledge representation, and improving learning accuracy; granular-ball neural network that firstly establishes an internally interpretable, attack-resistant, high-precision lightweight graph neural network learning model for image; granular-ball evolutionary computing that simultaneously achieves better optimization accuracy and convergence speed, and more.            <h5>Speaker: </h5>
            <p text-align="center">
              <img src="images/avatar/xiashuyin.jpg" alt="xiashuyin" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Pro.Dr. Shuyin Xia</div>
                Chongqing University of Posts and Telecommunications, Chongqing, China.
              </strong>
            </p>
            <br />
            <h5>Biography:</h5>
            Shuyin Xia is the Excellent Young Scholar, Professor at Chongqing University of Posts and Telecommunications, Ph.D. supervisor, Chongqing Distinguished Young Scholar, Chongqing Talent, Deputy Director of the Key Laboratory of Intelligent Computing in Cyberspace Big Data, Ministry of Education, and Vice Dean of the Institute of Frontier Interdisciplinary Research. He has led multiple national key R&D programs and National Natural Science Foundation projects, and published over 30 papers as the first author in important artificial intelligence journals such as IEEE TPAMI, TNNLS, TKDE, TCYB, etc. He has received the First Prize of the Wu Wenjun Artificial Intelligence Technology Progress Award and the Second Prize of the National Teaching Achievement Award. Research interests: multi-granularity deep learning, multi-granularity neural networks, granular-ball rough sets, granular-ball clustering, machine learning based on granular computing, multi-granularity granular-ball computation, etc.
            <br />
          </p>
          {/* <hr />
          <span>&nbsp;</span>
          <p align="justify">
            <h4>Title: Complex data quality control techniques: challenges and developments</h4>
            <br />
            <h5>Abstract:</h5>
            Complexity is the intrinsic property of big data versus small data, and also is the core challenge faced by current big data quality control and data governance. High-dimensionality, unstructured data, multi-modal data, etc., are all specific characteristics of big data complexity, and they lead to need more complex techniques in big data area. However, data quality is still an issue neglected by us. Dr. Cao will introduce the research framework of data quality control, including its research topics and research methods. The relationships between data quality control and governance will be discussed. In order to illustrate the complexity intuitively, several representative complex data quality control techniques will be shown. Then, he will give a clear viewpoint: The complexity of data quality control techniques is seriously underrated and the progress of data governance is highly overrated. So, we need to reconsider circumstances of big data and propose some new solutions to get real value from our data.
            <br />
            <h5>Speaker: </h5>
            <p text-align="center">
              <img src="images/avatar/jianjun.png" alt="Waqas" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. Jianjun Cao</div>
                The Sixty-third Research Institute, National University of Defense Technology, China.
              </strong>
            </p>
            <br />
            <h5>Biography:</h5>
            Dr. Jianjun Cao received a Bachelor of Engineering degree in Computer Science and technology from Qingdao University of China, and a Master of Engineering degree in Computer Application Technology from Ordnance Engineering College of China, respectively. He was awarded a Doctor of Philosophy degree in Signal Processing and Pattern Recognition from Ordnance Engineering College of China. Dr. Cao currently is a full Professor at the Sixty-third Research Institute, National University of Defense Technology, China. In 2008, he created Information Quality Research Group (IQRG), and began to research and practice data quality control techniques. He has published over 100 peer-reviewed papers and two books in the field. His research work has been supported by National Natural Science foundation of China and special supported from China Postdoctoral Science Foundation.
            <br />
          </p> */}

          {/* a new speaker */}

          {/* <span>&nbsp;</span>
          <span>&nbsp;</span>

          <p align="justify">
            <h4>Title: Qua Vadis AI?</h4>
            <br />
            <h5>Abstract:</h5>
            During the last two decades, profound technological changes have
            occurred around us, supported by disruptive advances both on the
            software and hardware sides. Additionally, we have witnessed a
            cross-fertilization of concepts and an amalgamation of information,
            communication, and control technology-driven approaches. This has
            led to what is termed as digital transformation, i.e., the
            integration of digital technology into all areas of business,
            fundamentally changing how companies operate and deliver value to
            customers. The most recent development is integrating Artificial
            Intelligence (AI) in digital transformation as the primary enabler
            and the facilitator. It is expected that the applications of AI will
            truly transform our world and impact all facets of society, economy,
            living, working, healthcare and technology.
            <br />
            <br />
            The study of artificial intelligence (AI) has been a continuous
            endeavor of scientists and engineers for over 65 years. The simple
            contention is that human-created machines can do more than just
            labor-intensive work; they can develop human-like intelligence. AI
            has been very appealing as it aligns with the nature of human beings
            in terms of their never-satisfied demands for higher productivity on
            the one hand and, on the other hand, the curiosity of how we
            understand and try to change the world. Having gone through several
            historical stages with several winters, AI has become a leading
            technology today and plays novel roles like never. Therefore, it is
            time to discuss the past, the present, and the future of both the AI
            tools and the AI &quot;beings” at this juncture. In this presentation, in
            addition to the technical aspects of AI technology in short to
            mid-term, thoughts and insights are also presented regarding the
            symbiotic relationship of AI and humans in the long run.
          </p>
          <br/>
            <h4>Speaker: </h4>
            <br/>
          <p text-align="center">
            <img src="images/avatar/okyay.jpg" alt="okyay" width={159} />
          </p>
          <strong>
            <div id="name">Prof. Okyay Kaynak</div>
            <br />
              IEEE Fellow
              <br />
            Professor, Bogazici University.
          </strong>
          <br/>
          <br/>

          <p align="justify">
            <h5>Biography:</h5>
            Okyay Kaynak received the B.Sc. degree with first-class honors and
            Ph.D. degrees in electronic and electrical engineering from the
            University of Birmingham, UK, in 1969 and 1972, respectively. <br />
            <br />
            From 1972 to 1979, he held various positions within the industry. In
            1979, he joined the Department of Electrical and Electronics
            Engineering, Bogazici University, Istanbul, Turkey, where he is
            currently a Professor Emeritus, holding the UNESCO Chair on
            Mechatronics. He has held long-term (near to or more than a year)
            Visiting Professor/Scholar positions at various institutions in
            Japan, Germany, the U.S., Singapore, and China. His current research
            interests are in the broad field of intelligent systems. He has
            authored three books, edited five, and authored or co-authored more
            than 450 papers that have appeared in various journals and
            conference proceedings.
            <br />
            <br />
            Dr. Kaynak has served as the Editor in Chief of IEEE Trans. on
            Industrial Informatics, IEEE/ASME Trans. on Mechatronics and as the
            Co-Editor in Chief of IEEE Trans. on Industrial Electronics. He
            presently serves as the Founding Editor-in-Chief of Springer journal
            Discover Artificial Intelligence. Additionally, he is on the
            Editorial or Advisory Boards of several scholarly journals. He has
            received the Chinese Government&apos;s Friendship Award, Humboldt
            Research Prize, Doctor Honoris Causa, Obuda University, Hungary
            (2020) and the Academy Prize of the Turkish Academy of Sciences
            (2020). He is a member of this Academy.
          </p>
          <hr /> */}
          {/* begin a new speaker */}
          {/* <span>&nbsp;</span>
          <span>&nbsp;</span>

          <p align="justify">
            <h4>Title: Adapting swarm intelligent algorithms to specific optimization problems</h4>
            <br />
            <h5>Abstract:</h5>
            The No Free Lunch theorem states that &quot;any two optimization algorithms are equivalent when their performance is averaged across all possible problems”. This means that there is no algorithm able to solve all optimization problems. Some of these problems suffer from high computational costs to be solved. In fact, the application of deterministic algorithms generally provides the final result in a non-polynomial time. Therefore, high complexity problems cannot be solved by using exhaustive methods. Thus, non-deterministic algorithms are applied. A non-deterministic algorithm can exhibit different behaviours on different runs. The non-deterministic algorithms are often used to find an approximation to a solution. Therefore, heuristic approaches are useful to solve such kind of problems. Among heuristic methods, Swarm Intelligent (SI) algorithms can be very useful to solve high complexity optimization problems.<br/><br/>

          This presentation will deal with the main features of Swarm Intelligence and the possibility of adapting SI algorithms to specific optimization problems.
          </p>
          <br/>
          <h4>Speaker: </h4>
          <br/>
          <p text-align="center">
            <img src="images/avatar/danilo_istit.jpg" alt="danilo_istit" width={159} />
          </p>
          <strong>
            <div id="name">Prof. Danilo Pelusi</div>
              <br />
              Associate Professor of Computer Science, University of Teramo.
          </strong>
          <br></br>
          <br></br>

          <p align="justify">
            <h5>Biography:</h5>
            Danilo Pelusi received the Ph.D. degree in Computational Astrophysics from the University of Teramo, Italy. He is an Associate Professor at the Department of Communication Sciences, University of Teramo. Editor of books in Springer and Elsevier, he is/was an Associate Editor of IEEE Transactions on Emerging Topics in Computational Intelligence, IEEE Access and International Journal of Machine Learning and Cybernetics. Guest editor for Elsevier, Springer, MDPI, Hindawi and Inderscience journals, he belongs to the editorial board member of many journals. Keynote speaker and chair of IEEE conferences and inventor of patents on Artificial Intelligence, his research interests include Fuzzy Logic, Neural Networks, Information Theory, Machine Learning and Evolutionary Algorithms.
          </p>

          <br/>
          <hr />

          <br/> */}


        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Speakers;
